module.exports = __webpack_public_path__ + "static/media/wegotyourback.d0176a23.png";